export const authConstants = {
  AUTH_USER_SUCCESS: 'AUTH_USER_SUCCESS',
  AUTH_USER: 'AUTH_USER',
  UNAUTH_USER: 'UNAUTH_USER',
  AUTH_USER_ERROR: 'AUTH_USER_ERROR'
}
